
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from "moment";
import * as service from '../../../../services/service';


function AddItemDemand() {
    const [state, setState] = useState({
        demandno: '', quantity1: '', quantity2: '', quantity3: '', quantity4: '',
        quantity5: '', quantity6: '', quantity7: '', quantity8: '', quantity9: '', quantity10: ''
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [demandDate, setDemandDate] = useState(new Date());
    const [vendorId, setVendorId] = useState('');
    const [VendorData, setVendorData] = useState([]);
    const [ItemCategoryData, setItemCategoryData] = useState([]);
    const [ItemData1, setItemData1] = useState([]);
    const [ItemData2, setItemData2] = useState([]);
    const [ItemData3, setItemData3] = useState([]);
    const [ItemData4, setItemData4] = useState([]);
    const [ItemData5, setItemData5] = useState([]);
    const [ItemData6, setItemData6] = useState([]);
    const [ItemData7, setItemData7] = useState([]);
    const [ItemData8, setItemData8] = useState([]);
    const [ItemData9, setItemData9] = useState([]);
    const [ItemData10, setItemData10] = useState([]);
    const [UnitData, setUnitData] = useState([]);
    const [itemCategoryId1, setItemCategoryId1] = useState('');
    const [itemCategoryId2, setItemCategoryId2] = useState('');
    const [itemCategoryId3, setItemCategoryId3] = useState('');
    const [itemCategoryId4, setItemCategoryId4] = useState('');
    const [itemCategoryId5, setItemCategoryId5] = useState('');
    const [itemCategoryId6, setItemCategoryId6] = useState('');
    const [itemCategoryId7, setItemCategoryId7] = useState('');
    const [itemCategoryId8, setItemCategoryId8] = useState('');
    const [itemCategoryId9, setItemCategoryId9] = useState('');
    const [itemCategoryId10, setItemCategoryId10] = useState('');
    const [itemId1, setItemId1] = useState('');
    const [itemId2, setItemId2] = useState('');
    const [itemId3, setItemId3] = useState('');
    const [itemId4, setItemId4] = useState('');
    const [itemId5, setItemId5] = useState('');
    const [itemId6, setItemId6] = useState('');
    const [itemId7, setItemId7] = useState('');
    const [itemId8, setItemId8] = useState('');
    const [itemId9, setItemId9] = useState('');
    const [itemId10, setItemId10] = useState('');
    const [unit1, setUnit1] = useState('');
    const [unit2, setUnit2] = useState('');
    const [unit3, setUnit3] = useState('');
    const [unit4, setUnit4] = useState('');
    const [unit5, setUnit5] = useState('');
    const [unit6, setUnit6] = useState('');
    const [unit7, setUnit7] = useState('');
    const [unit8, setUnit8] = useState('');
    const [unit9, setUnit9] = useState('');
    const [unit10, setUnit10] = useState('');

    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const navigate = useNavigate();
    // const params = useParams();

    const getVendors = () => {
        fetch(
            service.VENDOR_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.vendorId, label: item.vendorName }));
                setVendorData(data2);
            });
    };
    const getItemCategory = () => {
        fetch(
            service.ITEM_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.itemCategoryId, label: item.itemCategory }));
                setItemCategoryData(data2);
            });
    };
    const getItem = (cat, number) => {
        fetch(
            service.ITEM_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ItemCategoryId: cat,
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.itemId, label: item.item }));
                if (number === 1) {
                    setItemData1(data2);
                }
                else if (number === 2) {
                    setItemData2(data2);
                }
                else if (number === 3) {
                    setItemData3(data2);
                }
                else if (number === 4) {
                    setItemData4(data2);
                }
                else if (number === 5) {
                    setItemData5(data2);
                }
                else if (number === 6) {
                    setItemData6(data2);
                }
                else if (number === 7) {
                    setItemData7(data2);
                }
                else if (number === 8) {
                    setItemData8(data2);
                }
                else if (number === 9) {
                    setItemData9(data2);
                }
                else if (number === 10) {
                    setItemData10(data2);
                }
            });
    };

    const getUnit = () => {
        fetch(
            service.UNIT_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.unitId, label: item.unit }));
                setUnitData(data2);
            });
    };
    const getUnitByItem = (itmId, number) => {
        fetch(
            service.GET_UNIT_BY_ITEM,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ItemId: itmId,
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {                
                const data2 = ({ value: result.unitId, label: result.unit });
                if (number === 1) {
                    setUnit1(data2);                    
                }
                else if (number === 2) {
                    setUnit2(data2);
                }
                else if (number === 3) {
                    setUnit3(data2);
                }
                else if (number === 4) {
                    setUnit4(data2);
                }
                else if (number === 5) {
                    setUnit5(data2);
                }
                else if (number === 6) {
                    setUnit6(data2);
                }
                else if (number === 7) {
                    setUnit7(data2);
                }
                else if (number === 8) {
                    setUnit8(data2);
                }
                else if (number === 9) {
                    setUnit9(data2);
                }
                else if (number === 10) {
                    setUnit10(data2);
                }
            });
    };

    useEffect(() => {
        getVendors();
        getItemCategory();
        getUnit();
        // if (params.id > 0) {
        //     getDetailsById();
        // }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!vendorId) {
            isValid = false;
            errs[".vendor"] = "Please select vendor";
        }
        if (!itemCategoryId1) {
            isValid = false;
            errs[".itemCategoryId1"] = "Please select item category";
        }
        if (!itemId1) {
            isValid = false;
            errs[".itemId1"] = "Please select item";
        }
        // if (!unit1) {
        //     isValid = false;
        //     errs[".unit1"] = "Please select unit";
        // }
        if (!state.quantity1) {
            isValid = false;
            errs[".quantity1"] = "Please enter quantity";
        }
        if (!state.demandno) {
            isValid = false;
            errs[".demandno"] = "Please enter demand no.";
        }
        if (!demandDate) {
            isValid = false;
            errs[".demandDate"] = "Please enter demand date";
        }
        setErrors(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };
    const vendorChangeHandler = (ev) => {
        setVendorId(ev);
    }
    const itemcategory1ChangeHandler = (ev) => {
        setItemCategoryId1(ev);
        getItem(ev.value, 1)
    }
    const itemcategory2ChangeHandler = (ev) => {
        setItemCategoryId2(ev);
        getItem(ev.value, 2)
    }
    const itemcategory3ChangeHandler = (ev) => {
        setItemCategoryId3(ev);
        getItem(ev.value, 3)
    }
    const itemcategory4ChangeHandler = (ev) => {
        setItemCategoryId4(ev);
        getItem(ev.value, 4)
    }
    const itemcategory5ChangeHandler = (ev) => {
        setItemCategoryId5(ev);
        getItem(ev.value, 5)
    }
    const itemcategory6ChangeHandler = (ev) => {
        setItemCategoryId6(ev);
        getItem(ev.value, 6)
    }
    const itemcategory7ChangeHandler = (ev) => {
        setItemCategoryId7(ev);
        getItem(ev.value, 7)
    }
    const itemcategory8ChangeHandler = (ev) => {
        setItemCategoryId8(ev);
        getItem(ev.value, 8)
    }
    const itemcategory9ChangeHandler = (ev) => {
        setItemCategoryId9(ev);
        getItem(ev.value, 9)
    }
    const itemcategory10ChangeHandler = (ev) => {
        setItemCategoryId10(ev);
        getItem(ev.value, 10)
    }
    const item1ChangeHandler = (ev) => {
        setItemId1(ev);
        getUnitByItem(ev.value, 1);        
    }
    const item2ChangeHandler = (ev) => {
        setItemId2(ev);
        getUnitByItem(ev.value, 2);     
    }
    const item3ChangeHandler = (ev) => {
        setItemId3(ev);
        getUnitByItem(ev.value, 3);
    }
    const item4ChangeHandler = (ev) => {
        setItemId4(ev);
        getUnitByItem(ev.value, 4);
    }
    const item5ChangeHandler = (ev) => {
        setItemId5(ev);
        getUnitByItem(ev.value, 5);
    }
    const item6ChangeHandler = (ev) => {
        setItemId6(ev);
        getUnitByItem(ev.value, 6);
    }
    const item7ChangeHandler = (ev) => {
        setItemId7(ev);
        getUnitByItem(ev.value, 7);
    }
    const item8ChangeHandler = (ev) => {
        setItemId8(ev);
        getUnitByItem(ev.value, 8);
    }
    const item9ChangeHandler = (ev) => {
        setItemId9(ev);
        getUnitByItem(ev.value, 9);
    }
    const item10ChangeHandler = (ev) => {
        setItemId10(ev);
        getUnitByItem(ev.value, 10);
    }   

    function AddDetails(demandId, category, item, unit, quant) {
        fetch(
            service.ADD_ITEM_DETAILS_DEMAND,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    DemandId: demandId,
                    ItemCategoryId: category,
                    ItemId: item,
                    Unit: unit,
                    Quantity: quant,
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                    AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.messageType === 'Failed') {
                    // eslint-disable-next-line
                    alert(result.message);
                }
            });
    }

    function AddItemDetails(demandId) {
        if (itemCategoryId1 && itemId1 && unit1 && state.quantity1 != null && state.quantity1 > 0) {
            AddDetails(demandId, itemCategoryId1.value, itemId1.value, unit1.label, state.quantity1);
        }
        if (itemCategoryId2 && itemId2 && unit2 && state.quantity2 != null && state.quantity2 > 0) {
            AddDetails(demandId, itemCategoryId2.value, itemId2.value, unit2.label, state.quantity2);
        }
        if (itemCategoryId3 && itemId3 && unit3 && state.quantity3 != null && state.quantity3 > 0) {
            AddDetails(demandId, itemCategoryId3.value, itemId3.value, unit3.label, state.quantity3);
        }
        if (itemCategoryId4 && itemId4 && unit4 && state.quantity4 != null && state.quantity4 > 0) {
            AddDetails(demandId, itemCategoryId4.value, itemId4.value, unit4.label, state.quantity4);
        }
        if (itemCategoryId5 && itemId5 && unit5 && state.quantity5 != null && state.quantity5 > 0) {
            AddDetails(demandId, itemCategoryId5.value, itemId5.value, unit5.label, state.quantity5);
        }
        if (itemCategoryId6 && itemId6 && unit6 && state.quantity6 != null && state.quantity6 > 0) {
            AddDetails(demandId, itemCategoryId6.value, itemId6.value, unit6.label, state.quantity6);
        }
        if (itemCategoryId7 && itemId7 && unit7 && state.quantity7 != null && state.quantity7 > 0) {
            AddDetails(demandId, itemCategoryId7.value, itemId7.value, unit7.label, state.quantity7);
        }
        if (itemCategoryId8 && itemId8 && unit8 && state.quantity8 != null && state.quantity8 > 0) {
            AddDetails(demandId, itemCategoryId8.value, itemId8.value, unit8.label, state.quantity8);
        }
        if (itemCategoryId9 && itemId9 && unit9 && state.quantity9 != null && state.quantity9 > 0) {
            AddDetails(demandId, itemCategoryId9.value, itemId9.value, unit9.label, state.quantity9);
        }
        if (itemCategoryId10 && itemId10 && unit10 && state.quantity10 != null && state.quantity10 > 0) {
            AddDetails(demandId, itemCategoryId10.value, itemId10.value, unit10.label, state.quantity10);
        }

        // eslint-disable-next-line
        alert("Data Added Successfully.");
        window.location.reload();
    }
    const backHandler = () => {
        navigate('/stock/itemdemand');
    }

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_ITEM_DEMAND,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        DemandNo: state.demandno,
                        DemandDate: moment(demandDate).format("MM/DD/YYYY"),
                        VendorId: vendorId.value,
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        AddItemDetails(result.demandId)
                    }
                    else if (result.message.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <MDBox pt={4} pb={3} px={3} style={{ width: '90%' }}>
                                    <MDBox component="form" role="form">
                                        <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                            <Table aria-label="simple table">
                                                <TableRow>
                                                    <TableCell>
                                                        <MDInput label="Demand No" fullWidth value={state.demandno || ''}
                                                            name="demandno"
                                                            onChange={changeHandler}
                                                            id="demandno"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".demandno"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            Demand Date
                                                            <DatePicker
                                                                id="demandDate"
                                                                selected={demandDate}
                                                                onChange={date => setDemandDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                tabIndex={0}
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".demandDate"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={VendorData}
                                                                name="vendor"
                                                                value={vendorId}
                                                                onChange={vendorChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Vendor"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".vendor"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                            </Table>
                                            <Table aria-label="simple table">
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory1"
                                                                value={itemCategoryId1}
                                                                onChange={itemcategory1ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemCategoryId1"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData1}
                                                                name="item1"
                                                                value={itemId1}
                                                                onChange={item1ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemId1"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit1"
                                                                value={unit1}
                                                               // onChange={unit1ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit1"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity1 || ''}
                                                            name="quantity1"
                                                            onChange={changeHandler}
                                                            id="quantity1"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity1"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory2"
                                                                value={itemCategoryId2}
                                                                onChange={itemcategory2ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory2"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData2}
                                                                name="item2"
                                                                value={itemId2}
                                                                onChange={item2ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item2"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit2"
                                                                value={unit2}
                                                               // onChange={unit2ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit2"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity2 || ''}
                                                            name="quantity2"
                                                            onChange={changeHandler}
                                                            id="quantity2"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity2"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory3"
                                                                value={itemCategoryId3}
                                                                onChange={itemcategory3ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory3"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData3}
                                                                name="item3"
                                                                value={itemId3}
                                                                onChange={item3ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item3"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit3"
                                                                value={unit3}
                                                                // onChange={unit3ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit3"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity3 || ''}
                                                            name="quantity3"
                                                            onChange={changeHandler}
                                                            id="quantity3"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity3"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory4"
                                                                value={itemCategoryId4}
                                                                onChange={itemcategory4ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory4"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData4}
                                                                name="item4"
                                                                value={itemId4}
                                                                onChange={item4ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item4"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit4"
                                                                value={unit4}
                                                               // onChange={unit4ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit4"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity4 || ''}
                                                            name="quantity4"
                                                            onChange={changeHandler}
                                                            id="quantity4"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity4"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory5"
                                                                value={itemCategoryId5}
                                                                onChange={itemcategory5ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory5"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData5}
                                                                name="item5"
                                                                value={itemId5}
                                                                onChange={item5ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item5"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit5"
                                                                value={unit5}
                                                                // onChange={unit5ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit5"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity5 || ''}
                                                            name="quantity5"
                                                            onChange={changeHandler}
                                                            id="quantity5"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity5"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory6"
                                                                value={itemCategoryId6}
                                                                onChange={itemcategory6ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory6"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData6}
                                                                name="item6"
                                                                value={itemId6}
                                                                onChange={item6ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item6"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit6"
                                                                value={unit6}
                                                                // onChange={unit6ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit6"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity6 || ''}
                                                            name="quantity6"
                                                            onChange={changeHandler}
                                                            id="quantity6"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity6"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory7"
                                                                value={itemCategoryId7}
                                                                onChange={itemcategory7ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory7"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData7}
                                                                name="item7"
                                                                value={itemId7}
                                                                onChange={item7ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item7"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit7"
                                                                value={unit6}
                                                                // onChange={unit7ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit7"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity7 || ''}
                                                            name="quantity7"
                                                            onChange={changeHandler}
                                                            id="quantity7"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity7"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory8"
                                                                value={itemCategoryId8}
                                                                onChange={itemcategory8ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory8"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData8}
                                                                name="item8"
                                                                value={itemId8}
                                                                onChange={item8ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item8"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit8"
                                                                value={unit8}
                                                                // onChange={unit8ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit8"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity8 || ''}
                                                            name="quantity8"
                                                            onChange={changeHandler}
                                                            id="quantity8"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity8"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory9"
                                                                value={itemCategoryId9}
                                                                onChange={itemcategory9ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory9"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData9}
                                                                name="item9"
                                                                value={itemId9}
                                                                onChange={item9ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item9"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit9"
                                                                value={unit9}
                                                                // onChange={unit9ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit9"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity9 || ''}
                                                            name="quantity9"
                                                            onChange={changeHandler}
                                                            id="quantity9"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity9"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemCategoryData}
                                                                name="itemcategory10"
                                                                value={itemCategoryId10}
                                                                onChange={itemcategory10ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item Category"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcategory10"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={ItemData10}
                                                                name="item10"
                                                                value={itemId10}
                                                                onChange={item10ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Item"
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item10"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            <Select
                                                                options={UnitData}
                                                                name="unit10"
                                                                value={unit10}
                                                               // onChange={unit10ChangeHandler}
                                                                isSearchable
                                                                styles={selectStyles}
                                                                placeholder="Select Unit"
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit10"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Quantity" fullWidth value={state.quantity10 || ''}
                                                            name="quantity10"
                                                            onChange={changeHandler}
                                                            id="quantity10"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity10"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableContainer>
                                        <Table style={{ width: '90%' }}>
                                            <TableRow>
                                                <TableCell style={{ width: '50%', align: 'right' }}>
                                                    <MDBox mt={4} mb={1} textAlign="center">
                                                        {loading ? <Oval
                                                            heigth="20"
                                                            width="20"
                                                            color='grey'
                                                            ariaLabel='loading'
                                                        /> :
                                                            <MDButton color="info" onClick={submitHandler}>
                                                                SAVE
                                                            </MDButton>
                                                        }
                                                        {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                                    </MDBox>
                                                </TableCell>
                                                <TableCell style={{ width: '50%', align: 'left' }}>
                                                    <MDBox mt={4} mb={1} textAlign="center">
                                                        <MDButton color="info" onClick={backHandler}>
                                                            BACK
                                                        </MDButton>
                                                    </MDBox>
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddItemDemand;